import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { SpinnerComponent } from '../../../components/spinner/spinner.component';
import { UserDataService } from '../../../../shared/services/userData.service';
import { IRecordOfDistribution } from '../../../../shared/models/eopDocument';
import { Icons } from '../../../../shared/helpers/icons';
import { LucideAngularModule } from 'lucide-angular';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { PopupMessageComponent } from '../../../components/popup-message/popup-message.component';
import { EopDocumentService } from '../../../../shared/services/eopDocument.service';
import { NgxPaginationModule } from 'ngx-pagination';
import { DateUtils } from '../../../../shared/helpers/dateUtils';
import { IUserInfo } from '../../../../shared/models/contact';
import { NoEmojiDirective } from '../../../../shared/helpers/noEmoji.directive';
declare var initFlowbite: any;

@Component({
  selector: 'record-of-distribution',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    LucideAngularModule,
    SpinnerComponent,
    ReactiveFormsModule,
    PopupMessageComponent,
    NgxPaginationModule,
    NoEmojiDirective
  ],
  templateUrl: './record-of-distribution.component.html',
  styleUrl: './record-of-distribution.component.css'
})
export class RecordOfDistributionComponent implements OnInit, OnDestroy {
  icons = Icons;
  currentBuildingId: string | null = null;
  currentUser: IUserInfo | null = null;
  recordOfDistribution: IRecordOfDistribution[] = [];
  newEmail: string = '';
  emails: string[] = [];
  page = 1;
  itemsPerPage = 30;
  schoolYears: string[] = [];
  selectedSchoolYear: string = '';
  
  loading: boolean = false;
  displaySendEOPModal: boolean = false;
  isSchoolYearDropdownOpen = false;

  messageModal: string | null = null;
  popupMessage: string = '';
  
  sendEOPForm = new FormGroup({
    receiver_email: new FormControl('', Validators.required),
  })

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private userDataService: UserDataService,
    private eopDocumentService: EopDocumentService
  ) {}

  ngOnInit(): void {
    this.currentBuildingId = this.userDataService.getBuildingId();
    this.currentUser = this.userDataService.getUserData();
    this.schoolYears = DateUtils.getSchoolYears(6);
    this.selectedSchoolYear = DateUtils.getCurrentSchoolYear();
    this.loadRecordOfDistribution();
    
    setTimeout(() => {
      if (isPlatformBrowser(this.platformId)) {
        initFlowbite();
      }
    }, 50);
  }
  
  ngOnDestroy(): void {
    document.removeEventListener('click', this.handleClickOutside);
  }
  
  handleClickOutside = (event: MouseEvent) => {
    const target = event.target as HTMLElement;
    if (!target.closest('#schoolYearDropdownButton') && !target.closest('#schoolYearDropdown')) {
      this.isSchoolYearDropdownOpen = false;
    }
  };
  
  toggleSchoolYearDropdown(): void {
    this.isSchoolYearDropdownOpen = !this.isSchoolYearDropdownOpen;
  }

  handleSchoolYearSelect(year: string): void {
    this.selectedSchoolYear = year;
    this.isSchoolYearDropdownOpen = false;
    this.loadRecordOfDistribution();
  }

  loadRecordOfDistribution(): void {
    if (this.currentBuildingId && this.selectedSchoolYear) {
      this.loading = true;
      this.eopDocumentService.getRecordOfDistribution(this.currentBuildingId, this.selectedSchoolYear).subscribe({
        next: (response) => {
          this.loading = false;
          this.recordOfDistribution = response.data ? response.data : [];
        },
        error: (error) => {
          this.loading = false;
          console.error('Error loading record of distribution:', error.message);
        }
      })
    }
  }

  openSendEOPModal(): void {
    this.displaySendEOPModal = true;
  }

  closeSendEOPModal(): void {
    this.emails = [];
    this.newEmail = '';
    this.displaySendEOPModal = false;
  }

  addEmail(): void {
    const trimmed = this.newEmail.trim();
    if (trimmed && !this.emails.includes(trimmed)) {
      this.emails.push(trimmed);
      this.newEmail = '';
    }
  }

  removeEmail(index: number): void {
    this.emails.splice(index, 1);
  }

  sendEOP(): void {
    if (this.currentBuildingId && this.emails.length > 0) {
      this.loading = true;
      this.eopDocumentService.sendEOP(this.currentBuildingId, this.selectedSchoolYear, { receiver_emails: this.emails }).subscribe({
        next: (response) => {
          this.loading = false;
          this.displaySendEOPModal = false;
          if (response.has_error) {
            this.messageModal = 'unsuccess';
            this.popupMessage = response.message;
          } else {
            this.messageModal = 'success';
            this.popupMessage = 'This occurred after sending EOP.';
            this.loadRecordOfDistribution();
          }
        },
        error: (error) => {
          this.loading = false;
          this.displaySendEOPModal = false;
          console.error('Error:', error.message);
        }
      });
    }
  }
  
  canSave(): boolean {
    if (!this.currentUser) return false;
    return this.currentUser.can_edit || this.currentUser.can_admin;
  }

  resetMessageModal(): void {
    this.messageModal = null;
  }
}
